<template>
  <v-layout align-center column style="margin-top:100px;">
    <p class="Section-Title">Produk Pinjaman</p>
    <div class="Shape" v-bind:style="{ width: shapeWidth }">
      <v-row>
        <v-col>
          <p class="Title-Produk">
            Detil Produk
          </p>
        </v-col>
        <v-divider vertical style="margin-top:10px;"></v-divider>

        <!-- <v-col class="agri first-row">
          <img
            src="../../assets/pinjaman/AgriKilat-Logo.png"
            srcset="
              ../../assets/pinjaman/AgriKilat-Logo@2x.png 2x,
              ../../assets/pinjaman/AgriKilat-Logo@3x.png 3x
            "
            class="AgriKilat-Logo"
          />
        </v-col>
        <v-divider vertical style="margin-top:10px;"></v-divider> -->

        <v-col class="modal first-row">
          <!-- <div
            v-bind:style="{
              backgroundColor: '#efaf0b',
              opacity: 0.05,
              width: widthBackgroundTable,
              zIndex: 999,
              height: '930px',
              position: 'absolute',
            }"
          /> -->
          <img
            src="../../assets/pinjaman/ModalKilat-Logo.png"
            srcset="
              ../../assets/pinjaman/ModalKilat-Logo@2x.png 2x,
              ../../assets/pinjaman/ModalKilat-Logo@3x.png 3x
            "
            class="ModalKilat-Logo"
          />
        </v-col>
        <v-divider vertical style="margin-top:10px;"></v-divider>

        <v-col class="gaji first-row fas">
          <!-- <div
            v-bind:style="{
              backgroundColor: '#0ce4f2',
              opacity: 0.05,
              zIndex: 999,

              width: widthBackgroundTable,
              height: '930px',
              position: 'absolute',
            }"
          /> -->
          <img
            src="../../assets/pinjaman/GajiKilat-Logo.png"
            srcset="
              ../../assets/pinjaman/GajiKilat-Logo@2x.png 2x,
              ../../assets/pinjaman/GajiKilat-Logo@3x.png 3x
            "
            class="GajiKilat-Logo"
          />
        </v-col>
      </v-row>
      <v-divider />
      <v-row>
        <v-col>
          <p class="Title" v-bind:style="{ 'font-size': mainfontSize }">
            Penjelasan Produk
          </p>
        </v-col>
        <!-- <v-divider vertical></v-divider>
        <v-col class="agri">
          <p class="Desc" v-bind:style="{ 'font-size': subfontSize }">
            Solusi pinjaman non tunai untuk pengembangan usaha pertanian /
            peternakan.
          </p>
        </v-col> -->
        <v-divider vertical></v-divider>
        <v-col class="modal">
          <p class="Desc" v-bind:style="{ 'font-size': subfontSize }">
            Solusi pinjaman untuk memenuhi kebutuhan modal kerja.
          </p>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col class="gaji">
          <p class="Desc" v-bind:style="{ 'font-size': subfontSize }">
            Solusi pinjaman bagi karyawan yang membutuhkan.
          </p>
        </v-col>
      </v-row>
      <v-divider />
      <v-row>
        <v-col>
          <p class="Title" v-bind:style="{ 'font-size': mainfontSize }">
            Jenis Produk
          </p>
        </v-col>
        <!-- <v-divider vertical></v-divider>
        <v-col class="agri">
          <p class="Desc" v-bind:style="{ 'font-size': subfontSize }">
            Udang, Padi, Ternak
          </p>
        </v-col> -->
        <v-divider vertical></v-divider>
        <v-col class="modal">
          <p class="Desc" v-bind:style="{ 'font-size': subfontSize }">
            Invoice Financing, Working loan capital
          </p>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col class="gaji">
          <p class="Desc" v-bind:style="{ 'font-size': subfontSize }">
            Payroll,Employee Loan
          </p>
        </v-col>
      </v-row>
      <v-divider />
      <v-row>
        <v-col>
          <p class="Title" v-bind:style="{ 'font-size': mainfontSize }">
            Tenor Produk
          </p>
        </v-col>
        <!-- <v-divider vertical></v-divider>
        <v-col class="agri">
          <p class="Desc" v-bind:style="{ 'font-size': subfontSize }">
            1 s/d 6 bulan
          </p>
        </v-col> -->
        <v-divider vertical></v-divider>
        <v-col class="modal">
          <p class="Desc" v-bind:style="{ 'font-size': subfontSize }">
            1 s/d 12 bulan
          </p>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col class="gaji">
          <p class="Desc" v-bind:style="{ 'font-size': subfontSize }">
            1 s/d 6 bulan
          </p>
        </v-col>
      </v-row>
      <v-divider />
      <v-row>
        <v-col>
          <p class="Title" v-bind:style="{ 'font-size': mainfontSize }">
            Syarat & Ketentuan
          </p>
        </v-col>
        <!-- <v-divider vertical style="margin-bottom:10px;"></v-divider>
        <v-col
          class="List agri last-row"
          v-bind:style="{ 'font-size': subfontSize }"
        >
          <p>1. Identitas Pribadi (KTP, KK, NPWP, dan sebagainya)</p>
          <p>2. Legalitas Usaha (SIUP, Akta, SKU, TDP dan sebagainya).</p>
          <p>3. Memiliki Lahan Usaha</p>
          <p>4. Tergabung dalam Kelompok Tani</p>
          <p>5. Sudah menjalani usaha minimal satu tahun</p>
        </v-col> -->
        <v-divider vertical style="margin-bottom:10px;"></v-divider>
        <v-col
          class="modal last-row"
          v-bind:style="{ 'font-size': subfontSize }"
        >
          <p>1. Identitas Pemilik (KTP, NPWP dan sebagainya).</p>
          <p>
            2. Legalitas Usaha (SIUP, Akta, SITU, TDP, AMDAL dan sebagainya)
          </p>
          <p>3. Laporan Keuangan Perusahaan</p>
          <p>4. Invoice Pembiayaan</p>
        </v-col>
        <v-divider vertical style="margin-bottom:10px;"></v-divider>
        <v-col
          class="gaji last-row las"
          v-bind:style="{ 'font-size': subfontSize }"
        >
          <p>1. Identitas Pribadi (KTP, KK, NPWP, dan sebagainya)</p>
          <p>2. Karyawan Aktif yang Terdaftar</p>
          <p>3. Surat Keterangan Kerja</p>
        </v-col>
      </v-row>
    </div>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      pinjaman: [],
      shapeWidth: window.innerWidth / 1.5 + "px",
      widthBackgroundTable: window.innerWidth / 5.9 + "px",
      heightBackgroundTable:
        window.innerWidth / 1.47 + window.innerHeight / 10 + "px",
      // marginLeftLogo: window.innerWidth / 36 + "px",
      mainfontSize: window.innerWidth / 82 + "px",
      subfontSize: window.innerWidth / 120 + "px",
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    window.addEventListener("resize", this.resizeEventHandler);
  },
  computed: {},
  methods: {
    resizeEventHandler() {
      this.shapeWidth = `${window.innerWidth / 1.5}px`;
      this.widthBackgroundTable = window.innerWidth / 6 + "px";
      this.heightBackgroundTable =
        window.innerWidth / 1.47 + window.innerHeight / 10 + "px";

      this.mainfontSize = window.innerWidth / 82 + "px";
      this.subfontSize = window.innerWidth / 120 + "px";
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
};
</script>
<style scoped>
.col {
  padding-left: 0px;
  margin-left: 1px;
}
.first-row {
  margin-top: 10px;
}
.last-row {
  margin-bottom: 10px;
}
.agri {
  background-color: rgba(236, 249, 237, 0.5);
}
.modal {
  background-color: rgba(254, 247, 231, 0.5);
}
.fas {
  border-radius: 0 10px 0 0;
}
.las {
  border-radius: 0 0 10px 0;
}
.gaji {
  background-color: rgba(231, 252, 254, 0.5);
  margin-right: 8px;
}
[aria-orientation="horizontal"] {
  margin-top: 8px;
}
.Shape {
  flex-grow: 0;
  margin: 60px 0 0;
  padding: 2px;
  border-radius: 12px;
  border: solid 2px #f1f1f1;
}
.Section-Title {
  width: 100%;
  height: 30px;
  flex-grow: 0;
  margin: 0px 418px 0px 419px;
  font-family: Sora;
  font-size: 32px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
@media screen and (max-width: 1042px) {
  .Section-Title {
    width: 100%;
    height: 30px;
    flex-grow: 0;
    margin: 150px 418px 0px 419px;
    font-family: Sora;
    font-size: 28px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #252525;
  }
}
@media screen and (max-width: 842px) {
  .Section-Title {
    width: 100%;
    height: 30px;
    flex-grow: 0;
    margin: 150px 418px 0px 419px;
    font-family: Sora;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #252525;
  }
}
.AgriKilat-Logo {
  max-width: 100%;
  flex-grow: 0;
  display: block;
  margin: 20px auto 0px auto;
  object-fit: contain;
}
.ModalKilat-Logo {
  max-width: 100%;
  flex-grow: 0;
  display: block;
  margin: 20px auto 0px auto;
  object-fit: contain;
}
.GajiKilat-Logo {
  max-width: 100%;
  flex-grow: 0;
  display: block;
  margin: 20px auto 0px auto;
  object-fit: contain;
}
p {
  padding-left: 10px;
}
.Desc {
  flex-grow: 0;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Title {
  flex-grow: 0;
  margin: 0px 0px 0px 24px;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}

.Title-Produk {
  height: 23px;
  flex-grow: 0;
  margin: 23px 0px 18px 24px;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
</style>
